import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import EuroIcon from '@material-ui/icons/Euro'
import { Modal, Button } from '../root/components/common'

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 16
    },
    iconCircle: {
        width: 40,
        height: 40,
        borderRadius: '50%',
        background: theme.greenLight,
        color: theme.green,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.textPrimary,
        fontFamily: theme.fontFamily
    },
    body: {
        fontSize: 14,
        color: theme.textPrimary,
        fontFamily: theme.fontFamily,
        lineHeight: 1.5
    },
    rulesCard: {
        marginTop: 16,
        background: theme.lightBlueGrey,
        border: theme.border,
        borderRadius: theme.borderRadius,
        padding: 16
    },
    rulesList: {
        margin: 0,
        paddingLeft: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        fontSize: 13,
        color: theme.textPrimary,
        fontFamily: theme.fontFamily
    },
    rulesListItem: {
        lineHeight: 1.5
    },
    billingLink: {
        marginTop: 16,
        display: 'inline-block',
        color: theme.primary,
        fontFamily: theme.fontFamily,
        fontSize: 13,
        fontWeight: 'bold',
        textDecoration: 'underline',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        '&:hover': {
            opacity: 0.6
        }
    },
    actions: {
        marginTop: 24,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 12
    }
}))

export default function BillingInfoModal({ open, onConfirm, onCancel }) {
    const classes = useStyles()
    const locale = useSelector(state => state.main.locale)
    const history = useHistory()

    const goToBilling = () => {
        onCancel()
        history.push('/billing')
    }

    return (
        <Modal open={open} onClose={onCancel} size="md">
            <div className={classes.header}>
                <div className={classes.iconCircle}>
                    <EuroIcon />
                </div>
                <Typography className={classes.title}>
                    {locale.integrations.billingModalTitle}
                </Typography>
            </div>

            <Typography className={classes.body}>
                {locale.integrations.billingModalIntro}
            </Typography>

            <div className={classes.rulesCard}>
                <ul className={classes.rulesList}>
                    <li className={classes.rulesListItem}>
                        {locale.integrations.billingModalRulePrice}
                    </li>
                    <li className={classes.rulesListItem}>
                        {locale.integrations.billingModalRuleHeartbeat}
                    </li>
                    <li className={classes.rulesListItem}>
                        {locale.integrations.billingModalRuleGrandfathered}
                    </li>
                </ul>
            </div>

            <button
                type="button"
                className={classes.billingLink}
                onClick={goToBilling}
            >
                {locale.integrations.openBillingDashboard}
            </button>

            <div className={classes.actions}>
                <Button reverted onClick={onCancel}>
                    {locale.integrations.billingModalCancel}
                </Button>
                <Button onClick={onConfirm}>
                    {locale.integrations.billingModalConfirm}
                </Button>
            </div>
        </Modal>
    )
}
